import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type GetExternalTrainingModulesPreviewPlayerResponse = {
   title: string;
   external_training_moduleid: number;
   current_importid: number;
   launchLink: string;
};

export async function getExternalTrainingModulesPreviewPlayer(
   importid: number,
   { ...common }: CommonRequestOptions = {}
): Promise<GetExternalTrainingModulesPreviewPlayerResponse> {
   return makeRequest('get', `/external_training_modules/imports/${importid}/preview`, {
      ...common,
   });
}
